// extracted by mini-css-extract-plugin
export default {"item":"time_rule-module___item___c0fd22ed"};